// Below 1 MB, showing MB with one decimal rounds small files down to "0.0 MB" — use KB instead.
const formatFileSize = (bytes: number) =>
  bytes < 1024 * 1024 ? `${Math.max(1, Math.round(bytes / 1024))} KB` : `${(bytes / (1024 * 1024)).toFixed(1)} MB`;

export default formatFileSize;
